import { forwardRef } from "react";

import {
  TABLE_HEADER_CELL_CLASS_NAME,
  type TTHProps,
} from "@/ui/components/data-display/Table/Table.config";
import { cn } from "@/ui/lib/utils";

export const TH = forwardRef<HTMLTableCellElement, TTHProps>(
  (
    {
      className,
      scope,
      ...props
    },
    ref,
  ) => {
    return (
      <th
        {...props}
        ref={ref}
        scope={scope}
        data-component="TH"
        className={cn(TABLE_HEADER_CELL_CLASS_NAME, className)}
      />
    );
  },
);

TH.displayName = "TH";
